module.exports = __webpack_public_path__ + "img/cryptocurrency.e2425aa8.jpg";